import { IonInput, IonItem, IonLabel } from "@ionic/react"
import React from "react"

interface Props {
  value: number
  onChange: (value?: number) => void
}

const FormArea: React.FC<Props> = (props) => {
  const onChange = (value: string) => {
    if (!value) {
      props.onChange(undefined)
    }

    props.onChange(parseInt(value, 10))
  }

  return (
    <IonItem>
      <IonLabel position="floating">Fläche in m<sup>2</sup></IonLabel>
      <IonInput value={`${props.value || ''}`} onIonChange={e => onChange((e.target as HTMLInputElement).value)} />
    </IonItem>
  )
}

export default FormArea
